export const ranks = [
  { id:0, active:false, color:"#d4edbc", title: 'Stardust', short: 'SD' },
  { id:1, active:false, color:"#bfe1f6", title: 'Moon', short: 'M' },
  { id:2, active:false, color:"#e6cff2", title: 'Star', short: 'S' },
  { id:3, active:false, color:"#ffc8aa", title: 'Nebula', short: 'N' },
  { id:4, active:false, color:"#ffcd45", title: 'Supernova', short: 'SN' },
  { id:5, active:false, color:"#ffffff", title: 'Supernova Eclipse', short: 'SN+' }
];

export const fetchCardTypes = async () => {
  const res = await fetch("/cardtypes");
  if (!res.ok) throw new Error(`Erreur HTTP : ${res.status}`);
  return await res.json();
}